import { ReactNode } from 'react';
import classNames from 'classnames';

import * as S from './prompt-header.styles';

export type PromptHeaderProps = Readonly<{
  icon: ReactNode;
  title: ReactNode;
  /** Allows the header to shift to an inline layout on larger screens */
  extended?: boolean;
}>;

export function PromptHeader(props: Readonly<PromptHeaderProps>) {
  const { icon, title, extended } = props;
  return (
    <S.PromptHeader className={classNames({ extended })}>
      {icon}
      {title}
    </S.PromptHeader>
  );
}
